export default {
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100vw',
    position: 'relative',
  },
  fullWidth: {
    width: '100%',
  },
  headerImage: {
    width: '100vw',
    borderRadius: '0px 0px 30px 30px',
    opacity: 0.8,
    filter: ['grayscale(88%)', 'none'],
    minHeight: ['300px', '350px', '300px'],
    maxHeight: ['0px', '450px'],
    objectFit: 'cover',
  },
  imageContainer: {
    height: '100%',
    position: 'relative',
  },

  overlay: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    opacity: [0.8, 0.6],
    borderRadius: '0px 0px 30px 30px',
    backgroundColor: ['tmBlue', 'tmWhite'],
  },

  titleContainer: {
    position: 'absolute',
    top: ['35%', '55%'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  title: {
    color: ['tmWhite', 'tmBlue'],
    textTransform: 'uppercase',
    fontSize: ['3rem', '3.5rem'],
    letterSpacing: '2px',
  },
  bottomTitle: {
    color: ['tmWhite', 'tmBlue'],
    textTransform: 'uppercase',
    fontSize: ['5rem', '6rem'],
    lineHeight: '25px',
    letterSpacing: '2px',
    ':after': {
      content: '"."',
      color: 'tmRed',
      width: '10px',
      fontSize: '4rem',
      paddingLeft: '5px',
    },
  },
}
